module.exports = __webpack_public_path__ + "img/hohlschnitt_alugrau_ral7037.615b0e3f.jpg";